import React, {Component} from 'react'
import {
    Form,
    Input,
    Row,
    Col,
    Button,
    Table, message
} from 'antd';
import { reqCompanyList} from '../../api'
import LinkButton from '../../components/link-button'
import moment from 'moment';
import 'moment/locale/zh-cn';
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthButton = authorizeBase(Button)
const AuthLinkButton = authorizeBase(LinkButton)

moment.locale('zh-cn');

class CompanyList extends Component {

    state = {
        total: 0, // 商品的总数量
        companyList: [], // 商品的数组
        pageNum: 1,
        deviceView:false,
        action:'',
        companyId:''
    }

    /*
     初始化table的列的数组
     */
    initColumns = () => {

    }

    componentWillMount() {
        this.initColumns()
    }

    getProducts = async (pageNum) => {
        const pageSize = 10
        this.setState({
            pageNum: pageNum// 保存pageNum, 让其它方法可以看到
        })
        const {getFieldsValue} = this.props.form
        const values = getFieldsValue();
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        let result = await reqCompanyList(values)
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                companyList: result.data.rows
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {

        }

    }
    componentDidMount() {
        this.getProducts(1);
    }

    /*查询列表*/
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            values.pageNum = 1
            values.pageSize = 10
            if (!err) {
                this.reqCompanyList(values);
            }
        });
    };

    reqCompanyList = async (po) => {
        const result = await reqCompanyList(po);
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                companyList: result.data.rows
            })
            this.initColumns()
        } else {
            message.error(result.message);
        }
    };


    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        const pageNum = pagination.current
        this.getProducts(pageNum)
    };

    render() {
        const form = this.props.form
        const {getFieldDecorator} = form;

        const formItemLayout = {
            labelCol: {
                xs: {span: 9},
                sm: {span: 9},
            },
            wrapperCol: {
                xs: {span: 13},
                sm: {span: 13},
            },
        }

        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        }

        // 取出状态数据
        const {companyList, total,deviceView} = this.state
        const columns = [
            {
                title: '企业名称',
                dataIndex: 'companyName',
                width: '10%'
            },
            {
                title: '企业税号',
                dataIndex: 'companyTaxNo',
                width: '10%'
            },
            {
                title: '统一信用证代码',
                dataIndex: 'creditIdentification',
                width: '13%'
            },
            {
                title: '注册地',
                dataIndex: 'registerLocal',
            },
            {
                title: '法人姓名',
                dataIndex: 'legalPerson'
            },
            {
                title: '法人电话',
                dataIndex: 'legalPersonPhone',
            },
            {
                title: '法人邮箱',
                dataIndex: 'legalPersonEmail',
            },
            {
                title: '操作',
                dataIndex: 'opt',
                fixed: 'right',
                width: 250,
                render: (text, record) => {
                    return <span>
                           <AuthLinkButton  onClick={e => {this.props.history.push('/companyUpdate', {orderId: record.id})}}>修改</AuthLinkButton>
                        </span>
                }
            }
        ];

        return (
            <div className='box-shadow padding-20'>
                <div className='head-title'>企业列表</div>
                <br/>
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={6}>
                            <Form.Item label="企业名称">
                                {getFieldDecorator('companyName', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6} style={{float: 'right', marginBottom: '20px'}}>
                            <Button type='primary' htmlType="submit"
                                    style={{float: 'right', marginRight: '16.7%'}}>查询</Button>
                             <AuthButton type='primary' style={{float: 'right', marginRight: '20px'}} onClick={e => {
                                    this.props.history.push('/companyAdd')
                                }}>新增</AuthButton>
                        </Col>
                    </Row>
                </Form>

                <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    bordered
                    dataSource={companyList}
                    rowKey='id'
                    onChange={this.handleTableChange}
                    pagination={{
                        current: this.state.pageNum,
                        total: total,
                        showQuickJumper: true,
                    }}
                    size="middle"
                />
            </div>
        )
    }
}
const CompanyListFrom = Form.create()(CompanyList)
export default CompanyListFrom